/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CreateCustomerContactResult {
  Error = 0,
  Success = 1,
  RequestValidationFailed = 2,
  InvalidCompany = 3,
  EmailTaken = 4,
}
